import { twoFactorPolicy } from 'services'
import toastr from 'toastr'
import moment from 'moment'
import { hasPermits } from 'directives'
import { permits, user } from 'services'
import { funcModal } from 'components/modals'
import datepicker from 'components/datepicker'

const components = {
  funcModal,
  datepicker
}

const directives = {
  hasPermits
}

const computed = {
  roles () {
    return this.$store.state.roles.all;
  },

  form () {
    let data = {
      role: this.userData.role ?
      this.userData.role.id : null,
      user_id: this.userData.user_id
    }

    if (this.canUpdateReportStartDate) {
      data.report_start_date = this.report_start_date
        ? moment(this.report_start_date, ['MM/DD/YYYY']).format('YYYY-MM-DD')
        : null
    }

    return data
  },

  canUpdateReportStartDate () {
    return this.currentUser && this.currentUser.type == 'ims' &&
      permits.hasLocationPermits(this.locId, ['locationEmployee_update'])
  },

  user () {
    return this.userData.user || {};
  },

  country () {
    let countries = this.$store.state.address.countries;
    for (let i in countries) {
      if (countries[i].id == this.user.country_id) {
        return countries[i];
      }
    }
    return {};
  },

  state () {
    for (let i in this.country.states) {
      if (this.country.states[i].id == this.user.state_id) {
        return this.country.states[i];
      }
    }
    return {};
  }
}

const methods = {
  twoFactorActionLabel (value) {
    return twoFactorPolicy.label(value)
  },
  submit (modal) {
    this.errors = {}

    this.processing = true;
    this.form.role = this.role;
    this.$store.dispatch('locations.upsertEmployee', {id: this.$route.params.id, data: this.form})
    .then(() => {
      this.processing = false;
      let errors = this.$store.state.locations.errors;
      if (errors) {
        if (errors.errors) {
          this.errors = _.cloneDeep(errors.errors);
        }
        toastr.error(errors.message);
      } else {
        this.$refs.modal.close();
      }
    });
  },
  open () {
    this.$refs.modal.open();
  },
  syncReportStartDate (userData) {
    this.report_start_date = userData && userData.report_start_date
      ? moment(userData.report_start_date, ['YYYY-MM-DD']).format('MM/DD/YYYY')
      : null;
  }
}

const watch = {
  userData (n) {
    if (n.roles && n.roles.length) {
      this.role = n.roles[0].id
    } else {
      this.role = null;
    }
    this.syncReportStartDate(n);
  }
}

export default {
  name: 'edit-employee-modal',
  props: ['userData'],
  computed,
  components,
  directives,
  methods,
  watch,
  data () {
    // let role = null;
    // if (!_.isEmpty(this.userData)) {
    //   role = this.userData.roles[0].id
    // }

    return {
      // loading: true,
      processing: false,
      errors: {},
      locId: this.$route.params.id,
      role: null,
      report_start_date: null,
      currentUser: user.getUser()
    }
  },
  created () {
    this.syncReportStartDate(this.userData);

    if (permits.hasLocationPermits(this.$route.params.id, [
      'locationEmployee_update'
    ])) {
      this.$store.dispatch('roles.getAll', {
        type: 'location',
        _all: true,
        location_id: this.$route.params.id
      }).then(() => {
        this.loading = false;
      });
    }

  }
}
